import * as React from "react";
import { Supplier as SupplierModel } from "@models/supplier";
import { Divider, Modal, Table, Button } from "antd";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import FormattedDateTime from "@components/custom/FormattedDateTime";
import Message from "@constants/message";
import { PaginationDefaultParams } from "../custom/Paginator";
import { NavLink } from "react-router-dom";

type Props = {
  data: SupplierModel[];
  loading: boolean;
  deleteFn: (item: SupplierModel) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const SupplierTable: React.FC<Props> = props => {
  const { data, loading, currentPage, deleteFn, intl } = props;
  const { formatMessage } = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

  const deleteSupplier = (item: SupplierModel): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete"
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel"
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item)
    });
  };

  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`} />,
      width: 30,
      dataIndex: "index",
      key: "id",
      align:"right",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.name" defaultMessage={`Name`} />,
      width: 150,
      dataIndex: "name",
      align:"right",
      key: "name"
    },
    {
      title: <FormattedMessage id="app.address" defaultMessage={`Address`} />,
      width: 150,
      dataIndex: "address",
      key: "address"
    },
    {
      title: (
        <FormattedMessage
          id="app.modified_date"
          defaultMessage={`Modification Date`}
        />
      ),
      width: 150,
      dataIndex: "modified_at",
      key: "modified_at",
      render: (text, record) => <FormattedDateTime date={text} />
    },
    {
      title: "",
      key: "actions",
      width: 120,
      dataIndex: "actions",
      render: (text, record) => (
        <span>
          <NavLink to={`/suppliers/${record.id}/edit`}>
            <Button type="link" size={`small`}>
              <FormattedMessage id="app.edit" defaultMessage={`Edit`} />
            </Button>
          </NavLink>

          <Divider type="vertical" size={`small`} />

          <Button
            type="link"
            className={`danger`}
            onClick={() => deleteSupplier(record)}
          >
            <FormattedMessage id="app.delete" defaultMessage={`Delete`} />
          </Button>
        </span>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey={record => record.short_id}
    />
  );
};

export default injectIntl(SupplierTable);
